import React from 'react';
import { PageContext } from '../..';
import { CheckedCircle, UnCheckedCircle } from '../../../Components/Icons';
import { VendexRadioMeta } from '../../../models/VendexElement';

type Props = {
  id: string;
  data: VendexRadioMeta;
};

const VendexRadio: React.FC<Props> = ({ id, data }) => {
  const { checkedImage, uncheckedImage } = data;
  const {store } = React.useContext(PageContext);

  React.useEffect(() => {
    if (store.data[data.name] === undefined) {
      store.SET_DATA(`${data.name}, `);
    }
  }, []);

  const handleChange = () => {
    store.SET_DATA(`${data.name}, ${data.value}`);
  };

  if (!checkedImage && store.data[data.name] === data.value) return <CheckedCircle id={id} onClick={handleChange} data-vendex />;
  if (!uncheckedImage && store.data[data.name] !== data.value) return <UnCheckedCircle id={id} onClick={handleChange} data-vendex />;

  return <img id={id} src={store.data[data.name] === data.value ? checkedImage : uncheckedImage} onClick={handleChange} data-vendex />;
};

export default VendexRadio;
